import * as yup from "yup";
import i18n from "i18next";

export const createServiceDefinitionSaveValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
      required: i18n.t("validation.field.required"),
    },
  });

  return yup.object({
    id: yup.string().required(),
    content: yup.string().required(),
  });
};
